/* eslint-disable import/prefer-default-export */
//
// Track 2 document-quality chat — routes through the central agenticApiClient
// so it picks up the BFF-minted JWT + function-key defense-in-depth + CSRF,
// exactly like the other agents. A previous raw fetch() omitted the
// Authorization header entirely, so the JWT-gated FA always returned 401
// "Unauthorized". Do NOT reintroduce a bare fetch; the central client handles
// auth (Bearer token mint + x-functions-key + ?code).
import { agenticPost } from '../../utils/agenticApiClient';


export async function uploadCaseDocuments({ message, threadId,run_id }) {
  return agenticPost('/api/intake-review/chat', {
    message,
    ...(threadId && { thread_id: threadId }),
    ...(run_id ? {run_id}:{}),

  });
}
